import { IBaseService } from '@pit/core';
import { IPinItTrackFrontendApplicationService } from '../../services/interfaces/pin.it.track.frontend.application.service.interface';
import { IPinItTrackFrontendAuthenticationService } from '../../services/interfaces/pin.it.track.frontend.authentication.service.interface';
import { IPinItTrackFrontendDeviceService } from '../../services/interfaces/pin.it.track.frontend.device.service.interface';
import { IPinItTrackFrontendErrorService } from '../../services/interfaces/pin.it.track.frontend.error.service.interface';

export interface IPinItTrackFrontendCoreServicesAccessor extends IBaseService {

    applicationService?: IPinItTrackFrontendApplicationService;
    authenticationService?: IPinItTrackFrontendAuthenticationService;
    deviceService?: IPinItTrackFrontendDeviceService;
    errorService?: IPinItTrackFrontendErrorService;

}
